import { AboutPage } from 'PageContainer';
const About = () => {
  return (
    <>
      <AboutPage></AboutPage>
    </>
  );
};

export default About;
